import { getAuthToken, User } from "src/store/config";
import * as api from './api'
interface ApiResponse {
  data: User[];
  meta: {
    totalItems: number;
    itemsPerPage: number;
    totalPages: number;
    currentPage: number;
  }
};

// fetch user list
export const fetchUserList = async (data: {
  page: number;
  limit: number;
  search?: string;
}): Promise<ApiResponse> => {
  const params = {
    page: data.page,
    limit: data.limit,
     ...(data.search && { search: data.search }),
  };
  const token = getAuthToken();
  api.setHeaderAuthorization(token);
  const response: any = await api.get(`${process.env.REACT_APP_ADMIN_API_URL}/user`, params);
  return response;
};

// block unblock user
export const blockUser = (id: string) => {
  const token = getAuthToken();
  api.setHeaderAuthorization(token);
  return api.get(`${process.env.REACT_APP_ADMIN_API_URL}/user/${id}`);
}